/**
 * NoIndex — drop-in component that emits <meta name="robots"
 * content="noindex,follow"> via React Helmet. Use on any page that
 * should not appear in Google's index: admin consoles, dashboards,
 * draft/edit flows, authenticated/private pages, and cross-site
 * routes that aren't actually scoped to IndianFamilyTree.com.
 *
 * Example:
 *   export default function AdminFoo() {
 *     return (<>
 *       <NoIndex />
 *       ...page content...
 *     </>);
 *   }
 */
import { Helmet } from "react-helmet-async";

export default function NoIndex({ title }) {
  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      <meta name="robots" content="noindex,follow" />
      <meta name="googlebot" content="noindex,follow" />
    </Helmet>
  );
}
